module.exports = __webpack_public_path__ + "img/gamad_matana_yes.96ed23fc.png";